import { useEffect, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { FormLabel, Paper, Stack, Switch, Text } from 'shell/components';

export const useClearAssignmentSettingError = (field, invalid, errors, setErrors) => {
    const error = errors?.[field];
    useEffect(() => {
        if (!error || invalid || !setErrors) return;
        setErrors((current) => {
            if (!current[field]) return current;
            const next = { ...current };
            delete next[field];
            return next;
        });
    }, [error, field, invalid, setErrors]);
};

export const SettingsToggleCard = ({ title, description, checked, disabled, restricted, onChange }) => {
    const id = useId();
    const { t } = useTranslation('assignment');
    return (
        <Paper variant={'outlined'} sx={{ p: 5, borderRadius: 4 }}>
            <Stack spacing={2}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={4}>
                    <FormLabel id={id}>
                        <Text variant={'p1'} weight={'medium'}>
                            {title}
                        </Text>
                    </FormLabel>
                    <Switch
                        aria-labelledby={id}
                        checked={Boolean(checked)}
                        disabled={disabled || restricted}
                        tooltip={
                            restricted
                                ? {
                                      component: t(
                                          'institution-disabled',
                                          'Disabled by your institution. Request access or contact IT.'
                                      ),
                                  }
                                : undefined
                        }
                        onChange={(_, value) => {
                            if (!disabled && !restricted) onChange(value);
                        }}
                    />
                </Stack>
                <Text>{description}</Text>
            </Stack>
        </Paper>
    );
};
